import { useMutation } from '@tanstack/react-query';
import { useNotification } from '@refinedev/core';
import { useTranslation } from 'react-i18next';
import { deleteInitialQuestionnaire } from './initialQuestionnaire.api';

export const useDeleteInitialQuestionnaire = () => {
  const { open } = useNotification();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: deleteInitialQuestionnaire,
    onSuccess: (_) => {
      open?.({
        type: 'success',
        message: t('pages.studies.initialQuestionnaire.delete.success'),
      });
    },
    onError: () => {
      open?.({
        type: 'error',
        message: t('pages.studies.initialQuestionnaire.delete.error'),
      });
    },
  });
};
